import { lazy } from 'react';

export const LazyHandoffBankIdDevice = lazy(() =>
  import(/* webpackChunkName: "handoff-bankid-device" */ './HandoffBankIdDevice').then(
    (module) => ({
      default: module.HandoffBankIdDevice,
    })
  )
);
